 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin~administrators~funds~holdings~housefunds~liabilities~managers~operations~quotaholders~quotahol~a6fb0a1e":"admin~administrators~funds~holdings~housefunds~liabilities~managers~operations~quotaholders~quotahol~a6fb0a1e","administrators":"administrators","admin~funds~holdings~housefunds~managers~operations~quotaholders~quotaholdersoperations~returns":"admin~funds~holdings~housefunds~managers~operations~quotaholders~quotaholdersoperations~returns","managers":"managers","quotaholders":"quotaholders","admin~funds~holdings~housefunds~indexes~liabilities~operations~quant~quotaholdersoperations~returns~~500fb846":"admin~funds~holdings~housefunds~indexes~liabilities~operations~quant~quotaholdersoperations~returns~~500fb846","admin~quant":"admin~quant","admin":"admin","funds~holdings~housefunds~indexes~operations~quotaholdersoperations~returns":"funds~holdings~housefunds~indexes~operations~quotaholdersoperations~returns","funds":"funds","holdings":"holdings","housefunds":"housefunds","operations":"operations","quotaholdersoperations":"quotaholdersoperations","returns":"returns","liabilities":"liabilities","shareoptions":"shareoptions","shares":"shares","quant":"quant","indexes":"indexes","updates":"updates","user":"user","companies":"companies"}[chunkId]||chunkId) + "." + {"admin~administrators~funds~holdings~housefunds~liabilities~managers~operations~quotaholders~quotahol~a6fb0a1e":"f6f7f301","administrators":"bac7dda5","admin~funds~holdings~housefunds~managers~operations~quotaholders~quotaholdersoperations~returns":"59908ed4","managers":"780191ec","quotaholders":"dfd8b6e3","admin~funds~holdings~housefunds~indexes~liabilities~operations~quant~quotaholdersoperations~returns~~500fb846":"a07f4c97","admin~quant":"742dc2e9","admin":"f4e5be95","funds~holdings~housefunds~indexes~operations~quotaholdersoperations~returns":"65ee4316","funds":"9802c5a3","holdings":"093afbbe","housefunds":"37ee14b9","operations":"2656ae04","quotaholdersoperations":"3ae65afe","returns":"53ea1052","liabilities":"fc17bd7c","shareoptions":"79669bfa","shares":"205edca8","quant":"22cf20c6","indexes":"cee1f315","updates":"5f45bc6f","user":"d01e86e1","companies":"e4d5b828"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"administrators":1,"managers":1,"admin":1,"funds":1,"holdings":1,"housefunds":1,"operations":1,"quotaholdersoperations":1,"returns":1,"liabilities":1,"shareoptions":1,"shares":1,"indexes":1,"updates":1,"user":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin~administrators~funds~holdings~housefunds~liabilities~managers~operations~quotaholders~quotahol~a6fb0a1e":"admin~administrators~funds~holdings~housefunds~liabilities~managers~operations~quotaholders~quotahol~a6fb0a1e","administrators":"administrators","admin~funds~holdings~housefunds~managers~operations~quotaholders~quotaholdersoperations~returns":"admin~funds~holdings~housefunds~managers~operations~quotaholders~quotaholdersoperations~returns","managers":"managers","quotaholders":"quotaholders","admin~funds~holdings~housefunds~indexes~liabilities~operations~quant~quotaholdersoperations~returns~~500fb846":"admin~funds~holdings~housefunds~indexes~liabilities~operations~quant~quotaholdersoperations~returns~~500fb846","admin~quant":"admin~quant","admin":"admin","funds~holdings~housefunds~indexes~operations~quotaholdersoperations~returns":"funds~holdings~housefunds~indexes~operations~quotaholdersoperations~returns","funds":"funds","holdings":"holdings","housefunds":"housefunds","operations":"operations","quotaholdersoperations":"quotaholdersoperations","returns":"returns","liabilities":"liabilities","shareoptions":"shareoptions","shares":"shares","quant":"quant","indexes":"indexes","updates":"updates","user":"user","companies":"companies"}[chunkId]||chunkId) + "." + {"admin~administrators~funds~holdings~housefunds~liabilities~managers~operations~quotaholders~quotahol~a6fb0a1e":"31d6cfe0","administrators":"235b1dd2","admin~funds~holdings~housefunds~managers~operations~quotaholders~quotaholdersoperations~returns":"31d6cfe0","managers":"86099f57","quotaholders":"31d6cfe0","admin~funds~holdings~housefunds~indexes~liabilities~operations~quant~quotaholdersoperations~returns~~500fb846":"31d6cfe0","admin~quant":"31d6cfe0","admin":"f5405352","funds~holdings~housefunds~indexes~operations~quotaholdersoperations~returns":"31d6cfe0","funds":"22b34a9a","holdings":"4fd04e51","housefunds":"5547fb7e","operations":"c5965e16","quotaholdersoperations":"88b01e0c","returns":"ad0ba852","liabilities":"57aa4375","shareoptions":"7c6b12ba","shares":"72482e5c","quant":"31d6cfe0","indexes":"e9e1acbe","updates":"1e499142","user":"a22a567f","companies":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
